import { render } from "./KISRoot.vue?vue&type=template&id=216c0ffe"
import script from "./KISRoot.vue?vue&type=script&lang=js"
export * from "./KISRoot.vue?vue&type=script&lang=js"

import "./KISRoot.vue?vue&type=style&index=0&id=216c0ffe&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__